/** Converts a document title into a safe, stable PDF filename stem. */
export function slugify(title: string): string {
  const slug = title
    .normalize("NFKD")
    .replace(/\p{M}/gu, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 60);

  return slug || "checklist";
}

export function downloadBytes(bytes: Uint8Array, filename: string): void {
  // Copy into an ArrayBuffer-backed view; BlobPart excludes SharedArrayBuffer views.
  const byteCopy = new Uint8Array(bytes.byteLength);
  byteCopy.set(bytes);
  const blob = new Blob([byteCopy.buffer], { type: "application/pdf" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.style.display = "none";
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
